<script setup>
import {onBeforeMount, reactive, ref, nextTick} from "vue";
import createTenantPost from "./components/createTenantPost/index.vue";
import { userInfoStore } from "@/store/store.js";
import creatTenantClubPersonal from "./components/creatTenantClubPersonal/index.vue";
import router from "@/router/index.js";
import {updateClubIgnore, updateClubPersonnelInfoIgnore} from "@/api/club/ignoreTenant.js";
import {getRoute} from "@/hooks/getRoute.js";
import {getStoreIgnore, updateStoreIgnore} from "@/api/store/ignoreTenant.js";
import moment from "moment/moment.js";
/*获取路由信息，带参则为修改*/
const {route} = getRoute()
// 用户信息
const userInfo = ref(userInfoStore().info);

// 带参则为修改
const isEdit = ref(false)
onBeforeMount(async () => {
  isEdit.value = Boolean(route.query.storeId)
  if (isEdit.value) {
    await getDetail()
  } else {
    ElMessage.error("信息获取失败")
    loading.value = true
  }
})

/*标签页相关*/
// 当前标签页
const currentTab = ref("1")
// 处理标签页改变
const handleTabChange = async (e) => {
  console.log("run in handleTabChange", e)
}

// 加载状态
const loading = ref(false)
// 处理表单提交新建俱乐部
const handleCreateTenantClub = async (form) => {
  try {
    loading.value = true
    await updateStoreIgnore(ruleForm.value)
    ElMessage.success("修改成功")
    router.push("/listTenantPost")
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}

/*基本信息相关*/
// 基本信息表单
const ruleForm = ref({
  storeLogo: null,
  name: null,
  nameEn: null,
  storeAddress: {
    provinceCode: null,
    cityCode: null,
    districtCode: null,
    addressDetail: null,
    addressDetailEn: null
  },
  // 营业时间
  operatingHours: [{
    operatingTime: [],
    weekdayOpen: null,
    weekdayClose: null,
    operatingStart: null,
    operatingEnd: null
  }],
  nonSelfOperatedLink: null,
  isSelfOperated: true,
  certificationType: null,
  partnerStores: [],
  referralOfficer: {
    name: null,
    phone: null
  },
  bikeStoreName: null,
  bikeStoreId: null,
  // 负责人信息
  contactName: null,
  phone: null,
  contactEmail: null,
  recipientInfo: {
    recipientName: null,
    recipientPhone: null,
    recipientAddress: {
      provinceCode: null,
      cityCode: null,
      districtCode: null,
      addressDetail: null
    }
  },
  tagIdList: [],
  featureTagIdList: [],
  assistsOperation: false,
  storeCoverImage: [],
  photoList: [],
  storeDiscoverCoverImage: null
})
// 创建商家俱乐部组件锚点
const createTenantPostRef = ref()
// 添加俱乐部主理人组件锚点
const creatTenantClubPersonalRef = ref()
// 获取商家信息
const getDetail = async () => {
  try {
    loading.value = true
    const res = await getStoreIgnore(route.query.storeId)
    console.log("res", res)
    ruleForm.value = res
    ruleForm.value.operatingHours.map(i => {
      i.operatingTime = [moment(moment().format("YYYY-MM-DD") + " " + i.operatingStart).format("YYYY-MM-DD HH:mm:ss"), moment(moment().format("YYYY-MM-DD") + " " + i.operatingEnd).format("YYYY-MM-DD HH:mm:ss")]
    })
    let temp = [ruleForm.value.storeAddress.provinceCode, ruleForm.value.storeAddress.cityCode]
    if (ruleForm.value.storeAddress.districtCode) temp.push(ruleForm.value.storeAddress.districtCode)
    createTenantPostRef.value.handleReviewAddressCode(temp)
    let tempRecipient = [ruleForm.value.recipientInfo.recipientAddress.provinceCode, ruleForm.value.recipientInfo.recipientAddress.cityCode]
    if (ruleForm.value.recipientInfo.recipientAddress.districtCode) tempRecipient.push(ruleForm.value.recipientInfo.recipientAddress.districtCode)
    createTenantPostRef.value.handleReviewRecipientAddressCode(tempRecipient)
    createTenantPostRef.value.handleReviewPic([ruleForm.value.storeCoverImage])
    createTenantPostRef.value.handleAvatarReviewPic([ruleForm.value.storeLogo])
    createTenantPostRef.value.handleEnvReview(ruleForm.value.photoList)
    if (ruleForm.value.storeDiscoverCoverImage) createTenantPostRef.value.handleReviewStoreDiscoverCoverPic([ruleForm.value.storeDiscoverCoverImage])
    nextTick(() => {
      createTenantPostRef.value.handleReviewTagList()
      createTenantPostRef.value.handleReviewFeatureTagList()
    })
    ruleFormPersonal.personnelInfo = res.personnelInfo
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}

/*主理人信息相关*/
// 主理人信息表单信息
const ruleFormPersonal = reactive({
  personnelInfo: [
    {
      avatar: null,
      name: null,
      nameEn: "Coming Soon ...",
      summaryInfo: [
        {
          summary: null,
          summaryEn: "Coming Soon ..."
        }
      ]
    }
  ]
})

</script>

<template>
  <el-tabs
      v-model="currentTab"
      type="card"
      class="demo-tabs"
      @tab-change="handleTabChange"
  >
    <el-tab-pane label="基本信息" name="1">
    </el-tab-pane>
  </el-tabs>
  <div v-loading="loading" v-show="currentTab === '1'" style="height: calc(100% - 55px)">
    <createTenantPost ref="createTenantPostRef" :is-edit="true" v-model="ruleForm" @success="handleCreateTenantClub"></createTenantPost>
  </div>
</template>

<style lang="scss" scoped>

</style>
